<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="users">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 md10 elevation-6>
                <div class="sub-window">
                    <v-toolbar  dark color="brown darken-3">
                        <v-toolbar-title>Pagos&nbsp;&nbsp;</v-toolbar-title>
                        <v-toolbar-title>
                            <v-container fill-height class="pb-0">
                                <v-row>
                                    <v-col cols="5" class="pb-0">
                                        <v-menu
                                            v-model="bMenuDateFrom"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                }"
                                            >
                                                <v-text-field
                                                    dense
                                                    color="green darken-3"
                                                    v-model="dateFrom"
                                                    label="Del"
                                                    prepend-icon="mdi-calendar-start"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                color="green darken-3"
                                                v-model="dateFrom"
                                                @input="bMenuDateFrom = false"
                                            ></v-date-picker>
                                        </v-menu>             
                                    </v-col>
                                    <v-col cols="5" class="pb-0">
                                        <v-menu
                                            v-model="bMenuDateTo"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template
                                                v-slot:activator="{
                                                    on,
                                                }"
                                            >
                                                <v-text-field
                                                    dense
                                                    color="green darken-3"
                                                    v-model="dateTo"
                                                    label="al"
                                                    prepend-icon="mdi-calendar-end"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                color="green darken-3"
                                                v-model="dateTo"
                                                @input="bMenuDateTo = false"
                                            ></v-date-picker>
                                        </v-menu>             
                                    </v-col>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon text @click="onSearch" v-on="on">
                                                <v-icon>mdi-magnify</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Buscar</span>
                                    </v-tooltip>
                                </v-row>
                            </v-container>
                        </v-toolbar-title>
                        
                       
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="(selectedPayments.length === 0 )"
                                text
                                class="text-none"
                                @click="onExcel"
                            ><v-icon>mdi-microsoft-excel</v-icon>&nbsp;Exportar a Excel</v-btn>
                            <v-btn
                                :disabled="(payments.length === 0 )"
                                text
                                class="text-none"
                                @click="onClear"
                            ><v-icon>mdi-delete-empty-outline</v-icon>&nbsp;Limpiar resultados</v-btn>
                            
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item  @click="onExcel">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-microsoft-excel</v-icon>&nbsp; Exportar a Excel
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item  @click="onClear">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-delete-empty-outline</v-icon>&nbsp; Limpiar resultados
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de pagos: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de pagos: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Info de pago seleccionado: *********************** -->
                            <v-flex xs12>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="brown lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ searchResult }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-credit-card-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout wrap justify-space-between>
                                                <v-flex xs12>
                                                    <!-- hide-default-footer -->
                                                    <!-- :items-per-page="(payments.length < 21 ? payments.length: 20)" -->
                                                    <v-data-table
                                                        readonly
                                                        fixed-header
                                                        :headers="paymentsHeader"
                                                        :items="payments"
                                                        item-key="pagoid"
                                                        v-model="selectedPayments"
                                                        locale="es-MX"
                                                        class="elevation-1"
                                                        show-select
                                                        dense
                                                        height="400"
                                                        no-data-text="No hay pagos registrados en estas fechas."
                                                        
                                                        :footer-props="{
                                                            'items-per-page-options':[(payments.length < 21 ? payments.length: 20)],
                                                            'disable-items-per-page': true,
                                                        }"
                                                        sort-by="fecha"
                                                    >
                                                    </v-data-table>
                                                </v-flex>
                                            </v-layout>

                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de pago seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para pedir que se introduzcan fechas válidas: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bInvalidDates"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Fechas no válidas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-calendar-month</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >{{ errorMessage }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidDates = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzcan fechas válidas *********************************** -->


                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Pagos</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay pagos registrados entre esas fechas.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        
                        <!-- Termina renglón único para lista de pagos y pago seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de pagos y pago seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'users',
    data() {
        return {
            drawer: false,
            bInvalidDates: false,

            bMenuDateFrom: false,
            bMenuDateTo: false,
            dateFrom: '',
            dateTo: '',
            
            errorMessage: '',
            bExcelNotCreated: false, //Indica que el reporte en Excel no se pudo generar.

            paymentID: 0,            
            searchResult: '',
            bDeletingUser: false,
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            selectedPayments: [],

            paymentsHeader: [
                {
                    text: 'Evento',
                    sortable: true,
                    align: 'left',
                    value: 'evento',
                },
                 {
                    text: 'Salón',
                    sortable: true,
                    align: 'left',
                    value: 'salon',
                },
                {
                    text: 'Folio',
                    sortable: true,
                    align: 'right',
                    value: 'folio',
                },
                {
                    text: 'Fecha del Pago',
                    sortable: true,
                    align: 'center',
                    value: 'fecha',
                },
                {
                    text: 'Concepto',
                    sortable: true,
                    align: 'left',
                    value: 'concepto'
                },
                {
                    text: 'Forma de pago',
                    sortable: true,
                    align: 'left',
                    value: 'formaPago'
                },
                {
                    text: 'Subtotal',
                    sortable: true,
                    align: 'right',
                    value: 'subtotal'
                },
                {
                    text: 'IVA',
                    sortable: true,
                    align: 'right',
                    value: 'iva'
                },
                {
                    text: 'Total',
                    sortable: true,
                    align: 'right',
                    value: 'total'
                }
            ],
            
        };
    },

    
    methods: {
        onClose() {
            this.payments = [];
            this.$router.push('/');
        },

        
        onExcel() {
            console.log("selectedPayments = ", this.selectedPayments);
            var paymentsToExport = {
                folios: []
            };

            for (let i = 0; i < this.selectedPayments.length; i ++)
            {
                paymentsToExport.folios.push(this.selectedPayments[i].folio);
            }

            //Al parecer el orden de la selectedPayments es independiente del orden de la v-data-table,
            //por lo que es mejor ordenar siempre el arreglo con base en el folio:
            paymentsToExport.folios.sort(function(a, b){return a - b});

            console.log("Payments to export: ", paymentsToExport);
            this.$store.dispatch('exportPaymentsToExcel', paymentsToExport);
        },

        onClear(){
            this.searchResult = "";
            this.payments = [];
            this.selectedPayments = [];
        },
        
        onSearch()
        {
            this.searchResult = "";
            this.selectedPayments = [];
            var bDataOK = false;
            
            //Valida las datos:
            if (this.dateFrom === '')
            {
                this.bInvalidDates = true;
                this.errorMessage = "Seleccione una fecha inicial para la búsqueda.";
            }
            else
            if (this.dateTo === '')
            {
                this.bInvalidDates = true;
                this.errorMessage = "Seleccione una fecha final para la búsqueda.";
            }
            else
            if (this.dateFrom > this.dateTo)
            {
                this.bInvalidDates = true;
                this.errorMessage = "La fecha inicial no puede ser posterior a la fecha final.";
            }
            else
            {
                bDataOK = true;
            }

            if (bDataOK)
            {
                const searchDates = {
                    fechaInicio: this.dateFrom,
                    fechaFin: this.dateTo
                }
                this.$store.dispatch('searchPayments', searchDates);
                this.searchResult = "Resultado de la búsqueda:"
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'users',
            'waitCursor',
        ]),

        payments: {
            get() {
                return this.$store.getters.payments;
            },
            set(payments) {
                this.$store.dispatch('updatePayments', payments);
            },
        },

        excelProcessed: {
            get() {
                return this.$store.getters.excelProcessed;
            },
            set(excelProcessed) {
                this.$store.dispatch('updateExcelProcessed', excelProcessed);
            },
        },

        excelPath: {
            get() {
                return this.$store.getters.excelPath;
            },
            set(excelPath) {
                this.$store.dispatch('updateExcelPath', excelPath);
            },
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },

    watch: {
        excelProcessed: function (value, oldValue) {
            //console.log('Fuera del if, excelPath = ', this.excelPath);

            if (this.excelProcessed) {
                this.excelProcessed = false;

                if (this.excelPath !== '') {
                    //console.log('path = ', this.excelPath);
                    window.open(this.excelPath);
                    this.excelPath = '';
                } else {
                    this.bExcelNotCreated = true;
                }
            }
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.users {
    background: url('../assets/fondo.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>